import { useQueries } from '@tanstack/react-query'
import { useState } from 'react'
import { VideoPreviewModal } from '@/shared/ui/VideoPreviewModal'
import { TaskPreviewMedia } from './TaskPreviewMedia'
import { Image } from 'antd'
import { fileKeys, getFilePreview } from '@/entities/file-asset'

interface TaskInputMediaPreviewsProps {
  fileIds: number[]
  enabled: boolean
  mediaType?: 'IMAGE' | 'VIDEO' | 'AUDIO'
}

function isVideoFileType(fileType?: string | null) {
  return fileType?.toLowerCase().includes('video') ?? false
}

export function TaskInputMediaPreviews({
  fileIds,
  enabled,
  mediaType,
}: TaskInputMediaPreviewsProps) {
  const [videoPreview, setVideoPreview] = useState<{
    fileId: number
    url: string
  }>()
  const previews = useQueries({
    queries: fileIds.map((fileId) => ({
      queryKey: fileKeys.preview(fileId),
      queryFn: async () => (await getFilePreview(fileId)).data,
      enabled,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
    })),
  })

  return (
    <div className="task-input-media-list" aria-label="输入素材预览">
      {fileIds.map((fileId, index) => {
        const preview = previews[index]
        const data = preview?.data
        return (
          <div key={fileId} className="task-input-media">
            <span className="task-input-media-stage">
              {data?.previewUrl ? (
                mediaType === 'AUDIO' ||
                data.fileType?.toLowerCase().includes('audio') ? (
                  <audio controls preload="metadata" src={data.previewUrl} />
                ) : mediaType === 'VIDEO' || isVideoFileType(data.fileType) ? (
                  <button
                    type="button"
                    className="task-input-video-link"
                    aria-label={`预览视频素材 ${fileId}`}
                    onClick={() =>
                      setVideoPreview({ fileId, url: data.previewUrl })
                    }
                  >
                    <TaskPreviewMedia
                      artifact={{
                        previewUrl: data.previewUrl,
                        mediaType: 'VIDEO',
                      }}
                      alt={`文件 ${fileId}`}
                    />
                  </button>
                ) : (
                  <Image
                    src={data.previewUrl}
                    alt={`文件 ${fileId} 预览`}
                    preview={{ src: data.previewUrl, mask: '预览素材' }}
                  />
                )
              ) : (
                <em>{preview?.isError ? '加载失败' : '加载中'}</em>
              )}
            </span>
            <small>文件 #{fileId}</small>
          </div>
        )
      })}
      <VideoPreviewModal
        open={enabled && Boolean(videoPreview)}
        src={videoPreview?.url}
        title={
          videoPreview
            ? `预览素材 · 视频文件 #${videoPreview.fileId}`
            : undefined
        }
        onClose={() => setVideoPreview(undefined)}
      />
    </div>
  )
}
